<div class="axis-has-sidebar">
  <aside-consent
    [consentSelection]="consentSelection"
    [activeStepSet]="activeStepSet"
  ></aside-consent>
  <div class="axis-page-container">
    <div class="axis-container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
